import { render, staticRenderFns } from "./discountZone.vue?vue&type=template&id=5c60bb40&scoped=true&"
import script from "./discountZone.vue?vue&type=script&lang=js&"
export * from "./discountZone.vue?vue&type=script&lang=js&"
import style0 from "./discountZone.vue?vue&type=style&index=0&id=5c60bb40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c60bb40",
  null
  
)

export default component.exports